
<template>
  <div class="search-type">
    <p v-for="item in data" :key="item.label">
      <span v-show="!item.hide" class="search-item">
        <span class="search-label">{{ item.label }}：</span>
        <component
          :ref="item.name"
          style="position: relative"
          v-bind:is="item.tag ? item.tag : 'RadioGroup'"
          :data="item.list"
          :name="item.name"
          @change-list="handleSearch"
          @on-reset="onReset"
        />
      </span>
    </p>
  </div>
</template>
<script>
import RadioGroup from '@/components/RadioGroup';
import CheckboxGroup from '@/components/CheckboxGroup';
import CapacityCheckBox from '@/components/CapacityCheckBox';
export default {
  components: { RadioGroup, CheckboxGroup, CapacityCheckBox },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    handleSearch(val, name) {
      this.$emit('change-list', val, name);
    },
    onReset() {
      this.$emit('on-reset');
    },
  },
};
</script>
<style lang="less" scoped>
.search-type {
  max-width: 1170px;
  .search-item {
    display: flex;
    align-items: flex-start;
    margin-top: 3px;
    padding: 5px 0;
    font-size: 14px;
    border-bottom: 1px dashed #ccc;
    .search-label {
      display: inline-block;
      min-width: 80px;
      line-height: 17px;
      margin-top: 1px;
    }
    .checkbox-group {
      margin: 0;
    }
  }
  p {
    &:last-child span {
      border-bottom: none;
    }
  }
}
</style>
